(function () {
  'use strict';

  if (window.__bauMotionLoaded) return;
  window.__bauMotionLoaded = true;

  // Marca el <html> para que .bau-reveal arranque oculto. Si este JS falla, la marca nunca se aplica
  // y los items con .bau-reveal se ven sin animación — pero se ven (no quedan en opacity:0).
  document.documentElement.classList.add('bau-motion-ready');

  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var nodes = document.querySelectorAll('.bau-reveal:not(.is-visible)');
    if (!nodes.length) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    nodes.forEach(function (n) { io.observe(n); });
  }

  function animateCount(el) {
    var target = parseFloat(el.dataset.countTo);
    if (isNaN(target)) return;
    var duration = parseInt(el.dataset.countDuration, 10) || 1400;
    var suffix = el.dataset.countSuffix || '';
    var prefix = el.dataset.countPrefix || '';
    var decimals = parseInt(el.dataset.countDecimals, 10) || 0;
    var startTime = null;

    function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

    function step(now) {
      if (!startTime) startTime = now;
      var progress = Math.min((now - startTime) / duration, 1);
      var eased = easeOutCubic(progress);
      var value = target * eased;
      el.textContent = prefix + value.toFixed(decimals) + suffix;
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = prefix + target.toFixed(decimals) + suffix;
    }
    requestAnimationFrame(step);
  }

  function initCountUp() {
    var nodes = document.querySelectorAll('[data-count-to]:not([data-count-done])');
    if (!nodes.length) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) {
        n.dataset.countDone = '1';
        var prefix = n.dataset.countPrefix || '';
        var suffix = n.dataset.countSuffix || '';
        var decimals = parseInt(n.dataset.countDecimals, 10) || 0;
        n.textContent = prefix + parseFloat(n.dataset.countTo).toFixed(decimals) + suffix;
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.dataset.countDone = '1';
          animateCount(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });

    nodes.forEach(function (n) {
      n.textContent = (n.dataset.countPrefix || '') + '0' + (n.dataset.countSuffix || '');
      io.observe(n);
    });
  }

  function init() {
    initReveal();
    initCountUp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
